import CrudRepository from './CrudRepository'
export default class ChangeBundleStatusRepository extends CrudRepository {
  constructor () {
    super('core/api/bundles/changeState')
  }
}
